<template>
  <v-main class="pa-1 overflow-y-auto">
    <v-card-title class="headher">
      <div class="pa-3 pagetitle">基本情報</div>
      <v-spacer></v-spacer>

      <v-btn
        v-if="profuid == uid"
        elevation="0"
        color="#008CFF"
        style="color: white !important; font-size: 15px"
        class="rounded-pill"
        @click="profileEdit = true"
      >
        アカウント情報を編集
      </v-btn>
    </v-card-title>
    <v-card elevation="0" color="#F5F5F5" class="pa-2">
      <v-avatar v-if="profImageO" size="224">
        <v-img
          v-bind:src="profImageO"
          class="white--text align-end ma-0 rounded-circle"
        >
        </v-img>
      </v-avatar>
      <v-avatar v-else size="224">
        <v-img
          src="../../../assets/png/someone.png"
          class="white--text align-end ma-0 rounded-circle"
        >
        </v-img>
      </v-avatar>
      <v-card-title class="py-1 px-4" style="color: #294a66">
        ハンドルネーム
      </v-card-title>
      <h1 class="py-1 px-4">{{ currentName }}</h1>
      <v-chip color="#294A66" dark class="mt-2 mx-4" v-if="baseAdmins.gov.includes(profuid)"
        >自治体職員</v-chip
      >
    </v-card>
    <v-card elevation="0">
      <!--
        <v-card-title class="pt-10 pb-0" style="color: #294A66">
          役職・担当
        </v-card-title>
        <v-card-title class="py-0">
          <div style="color: #707070; font-size: 18px">
            {{ position }}
          </div>
        </v-card-title>
        -->
      <v-card-title class="py-0 pt-4" style="color: #294a66">
        メダル獲得数
      </v-card-title>
      <v-card-title class="pt-0">
        <div style="color: #707070; font-size: 18px">{{ medals }}枚</div>
      </v-card-title>
      <v-card-title class="py-0 pt-4" style="color: #294a66">
        ひとこと自己紹介
      </v-card-title>
      <v-card-title class="pt-0">
        <div style="color: #707070; font-size: 18px">
          {{ hitokoto }}
        </div>
      </v-card-title>
      <v-card-title class="py-0 pt-4" style="color: #294a66">
        メッセージ
      </v-card-title>
      <v-card-title class="pt-0">
        <div style="color: #707070; font-size: 18px">
          {{ message }}
        </div>
      </v-card-title>
      <v-card-title class="py-0 pt-4" style="color: #294a66">
        関連リンク
      </v-card-title>
      <v-card-title class="pt-0">
        <div style="color: #707070; font-size: 18px">
          <a :href="proLink" v-text="proLink"></a>
        </div>
      </v-card-title>
      <v-card-title class="py-0 pt-4" style="color: #294a66">
        ユーザー識別ID
      </v-card-title>
      <v-card-title class="pt-0">
        <div style="color: #707070; font-size: 18px">
          {{ dispuid }}
        </div>
      </v-card-title>
    </v-card>
    <v-card height="200" elevation="0">
    </v-card>
    <profile_edit
      :profileEdit="profileEdit"
      :device="device"
      @closeProedit="closeProedit"
    />
  </v-main>
</template>
  <script>
import firebase from "firebase/app";
import "firebase/database";
import profile_edit from "./profile_edit.vue";
import {createHash} from 'crypto'
export default {
  data() {
    return {
      db: null,
      currentName: "",
      message: "",
      proLink: "",
      hitokoto: "",
      profileEdit: false,
      medals: 0,
      count_ideapost: 0,
      count_comments: 0,
      count_proposals: 0,
      count_amendments: 0,
      profImageO: "",
      profImageS: "",
      dispuid: "",
    };
  },
  components: {
    profile_edit,
  },
  props: ["profuid", "device"],
  created() {
    this.db = firebase.firestore();
  },
  mounted() {
    this.updateinfo(this.profuid);
    this.updateCounter(this.profuid);
    this.updateDispuid(this.profuid);
  },
  watch: {
    profuid: function (profuid) {
      this.updateinfo(profuid);
      this.updateCounter(profuid);
      this.updateDispuid(profuid);
    },
  },
  methods: {
    closeProedit() {
      this.profileEdit = false;
      this.updateinfo(this.profuid);
    },
    updateDispuid(profuid){
      if(profuid.slice( 0, 4 )=="line:" ){
        this.dispuid =  "L-" + profuid.slice(5,11)
      }else if(profuid.slice( 0, 5 )=="staff:" ){
        const hash = createHash('sha256');
        hash.update(profuid.slice(6));
        this.dispuid =  "S-" + hash.digest('hex').slice( 0, 6 );
      }else{
        this.dispuid = profuid.slice( 0, 6 );
      }
    },
    updateinfo(uid) {
      this.updateCounter(uid);
      this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(uid)
        .get()
        .then((doc) => {
          //プロフィールの取得
          this.currentName = doc.data().name;
          this.message = doc.data().message;
          this.hitokoto = doc.data().hitokoto;
          this.proLink = doc.data().relatedLink;
          this.profImageO = doc.data().profImageO;
          this.profImageS = doc.data().profImageS;
          this.medals = doc.data().medals;
        });
    },
    updateCounter(uid) {
      this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(uid)
        .collection("counter")
        .doc("counter")
        .get()
        .then((doc) => {
          //カウンターの取得
          if (doc.data() != undefined) {
            if (doc.data().count_ideapost != undefined) {
              this.count_ideapost = doc.data().count_ideapost;
            }
            if (doc.data().count_comments != undefined) {
              this.count_comments = doc.data().count_comments;
            }
            if (doc.data().count_proposals != undefined) {
              this.count_proposals = doc.data().count_proposals;
            }
            if (doc.data().count_amendments != undefined) {
              this.count_amendments = doc.data().count_amendments;
            }
          }
        });
    },
  },
  computed: {
    uid() {
      return this.$store.state.auth?.user?.uid || "";
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    baseAdmins() {
      return this.$store.state.admins;
    },
  },
};
</script>
  <style scoped>
.headher {
  position: sticky;
  top: 0;
  z-index: 5;
  background: white;
}
.pagetitle {
  font-size: large;
  color: #707070;
}
* {
  font-family: mplus-2c-medium;
}
</style>